import { RouterProvider } from '@tanstack/react-router'
import { useEffect } from 'react'
import { AppProviders } from './app/providers'
import { router } from './app/router'
import { performanceMonitor, performanceWarnings } from './shared/utils/performance'
import { bundleAnalyzer } from './shared/utils/bundleAnalysis'

function App() {
  useEffect(() => {
    
    if (process.env.NODE_ENV === 'development') {
      console.log('🚀 Performance monitoring initialized')
      
      // Log initial performance metrics
      const summary = performanceMonitor.getSummary()
      if (summary) {
        console.log('📊 Initial performance metrics:', summary)
      }
      
      // Set up periodic memory usage warnings
      const memoryCheckInterval = setInterval(() => {
        performanceWarnings.warnMemoryUsage()
      }, 30000) // Check every 30 seconds
      
      return () => {
        clearInterval(memoryCheckInterval)
        performanceMonitor.disconnect()
        bundleAnalyzer.disconnect()
      }
    }
  }, [])

  return (
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  )
}

export default App
